import { DeepBoxError } from '@/models'
import { useErrorStore } from '@/stores/error/error'

class DeepErrorHandlerService {
  static error(error: Error | DeepBoxError) {
    const errorStore = useErrorStore()
    errorStore.create(error)
  }

  static clear() {
    const errorStore = useErrorStore()
    errorStore.error = undefined
  }

  static hasError() {
    const errorStore = useErrorStore()
    return !!errorStore.error
  }

  static clearErrorIfExists() {
    if (this.hasError()) {
      this.clear()
    }
  }
}

export default DeepErrorHandlerService
